<template>
    <div class="webim-color-select section-item-line">
        <div class="section-item-label">
            主题色
        </div>
        <div class="section-item-content">
            <div class="webim-color-select__radio">
                <v-radio-group
                    v-model="selectColor"
                    @input="onChangeColor"
                    class="color-list"
                >
                    <v-radio
                        v-for="colorItem in colorList"
                        :key="colorItem.value"
                        :value="colorItem.value"
                        :class="'color-' + colorItem.value"
                        class="color-list__cell"
                        name="webim-color"
                    />
                    <v-radio
                        :key="CUSTOMER_COLOR_VALUE"
                        :value="CUSTOMER_COLOR_VALUE"
                        class="color-list__color-picker"
                        name="webim-color"
                    >
                        <div class="trigger-color-picker" />
                    </v-radio>
                </v-radio-group>
                <div class="ui-input-color">
                    <div class="ui-input-color__content">
                        <span class="ui-input-color__sign">#</span>
                        <input
                            ref="colorInput"
                            :value="currentColor"
                            @change="onChangeColorInput"
                            @focus="onFocusColorInput"
                            class="ui-input-color__input"
                            type="text"
                            maxlength="6"
                            autofocus
                            placeholder="输入色值"
                        >
                        <div
                            v-popper:color.click
                            class="trigger-popper-placeholder"
                        >
                            <div
                                :style="colorStyle"
                                class="ui-input-color__preview"
                            />
                            <v-icon
                                class="ui-input-color__arrow"
                                name="arrow_dropdown"
                            />
                        </div>
                    </div>
                    <v-popper
                        ref="color"
                        :offset="-97"
                        clazz="ui-input-color__popper"
                        placement="bottom-start"
                        priority="tunning"
                    >
                        <chrome-picker
                            :value="colors"
                            @input="onChangeColorPicker"
                        />
                    </v-popper>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Icon } from 'vhtml-ui';
import VueColor from 'vue-color';
import { THEME_CONFIG, CUSTOMER_COLOR_VALUE } from '../conf';

const commonSprites = require.context('@/assets/icons', true, /[^.]+\.svg$/);
const sprites = require.context('../../../assets/icons', true, /[^.]+\.svg$/);
Icon.addSprites(commonSprites);
Icon.addSprites(sprites);

export default {
    components: {
        'chrome-picker': VueColor.Chrome,
    },

    props: {
        initData: {
            type: Object,
            default: () => {},
        },
    },

    data() {
        let color = '';
        color = color.split('#');
        return {
            // ready: false,
            // cacheValue: null,
            // cacheColor: color,
            colorPickerError: false,
            showColorPickerError: true,
            // changed: false,
            // confirmLoading: false,
            // showColorPicker: true,
            currentColor: color[1],
            colors: {
                hex: `#${color[1]}`,
            },
            colorList: [
                {
                    value: 1,
                },
                {
                    value: 0,
                },
                {
                    value: 2,
                },
                {
                    value: 3,
                },
                {
                    value: 4,
                },
            ],
            CUSTOMER_COLOR_VALUE,
            selectColor: 1,
        };
    },

    computed: {
        colorStyle() {
            return {
                backgroundColor: this.colors.hex || this.colors,
            };
        },
    },

    watch: {
        value(value) {
            this.selectColor = value;
            this.onChangeColor(value);
            // this.confirmLoading = false;
        },

        initData(nextValue) {
            this.getWebimColor(nextValue);
        },

        webimColor(value) {
            this.updateColor({
                hex: value,
            });
            // this.confirmLoading = false;
        },
    },

    mounted() {
        // window.addEventListener(
        //     'beforeunload',
        //     e => {
        //         if (this.changed) {
        //             const confirmationMessage = '您的编辑可能未保存，是否离开';
        //             (e || window.event).returnValue = confirmationMessage; // Gecko and Trident
        //             return confirmationMessage;
        //         }
        //         return e;
        //     },
        //     false
        // );
        // this.fetchGetWebimColor();
    },

    methods: {
        onChangeColor(value) {
            let color = {};
            this.selectColor = value;
            if (value !== CUSTOMER_COLOR_VALUE) {
                // this.showColorPicker = false;
                color = `#${THEME_CONFIG[value].color}`;
                this.updateColor({
                    hex: color,
                });
            } else {
                // this.showColorPicker = true;
                this.$nextTick(() => {
                    this.$refs.colorInput.select();
                });
            }
        },
        onFocusColorInput(e) {
            e.target.select();
        },
        onChangeColorInput(e) {
            const reg = /([\da-fA-F]{3}){1,2}/;
            const regColorWord = /[^\da-fA-F]/g;
            const { value } = e.target;
            this.currentColor = value;
            this.selectColor = -1;
            if (reg.exec(value) && reg.exec(value)[0] === value) {
                this.updateColor({
                    hex: `#${value}`,
                });
                this.colorPickerError = false;
            } else {
                let newStr = '';
                const newStrArr = [];
                newStr = this.currentColor.replace(regColorWord, '0');
                for (let i = 0; i < 6; i += 1) {
                    newStrArr[i] = newStr[i] || '0';
                }
                this.updateColor({
                    hex: `#${newStrArr.join('')}`,
                });
                this.colorPickerError = true;
            }
        },
        onChangeColorPicker(value) {
            this.selectColor = -1;
            this.updateColor(value);
        },
        updateColor(value) {
            const hex = value.hex.split('#');
            this.colors = value;
            this.currentColor = hex[1] ? hex[1] : '';
            // if (this.ready) {
            //     this.changed = true;
            // }
            if (`${this.selectColor}` === '-1') {
                this.onChangeColor(-1);
            }

            this.$emit('change', {
                value: this.selectColor,
                color: value.hex,
            });
        },
        // onConfirmColor() {
        //     this.fetchSetWebimColor({
        //         value: this.selectColor,
        //         color: this.colors.hex
        //     });
        // },
        // onCancelColor() {
        //     this.selectColor = this.cacheValue;
        //     this.updateColor({
        //         hex: this.cacheColor
        //     });
        //     this.onChangeColor(this.value);
        // },

        getWebimColor(data) {
            const value = parseInt(data.theme, 10) || 0;
            const color = data.styleConfig ? data.styleConfig.themeColor : `#${THEME_CONFIG[0].color}`;
            // this.cacheValue = value;
            // this.cacheColor = color;
            this.selectColor = value;
            this.updateColor({
                hex: color,
            });
            this.onChangeColor(value);
            // this.ready = true;
        },

        // fetchSetWebimColor(data) {
        //     this.confirmLoading = true;
        //     const params = {
        //         theme: data.value,
        //         styleConfig: {
        //             themeColor: data.color,
        //             detail: covertColorToStyle(data.color)
        //         }
        //     };
        //     this.$ajax
        //         .post('/tp/IMAccessSet/setPCIMTheme', params)
        //         .then(res => {
        //             if (+res.r === 0) {
        //                 this.$message.success('设置成功');
        //                 this.cacheValue = data.value;
        //                 this.cacheColor = data.color;
        //             } else {
        //                 this.$message.error(res.msg || '发生错误，请重试');
        //             }
        //             this.confirmLoading = false;
        //             this.changed = false;
        //         })
        //         .catch(err => {
        //             this.$message.error(err.msg || '发生错误，请重试');
        //             this.confirmLoading = false;
        //         });
        // }
    },
};
</script>

<style lang="less">
@import '~@/common/common';
@import './style';
</style>
